// extracted by mini-css-extract-plugin
module.exports = {"articlesList":"ArticlesList_articlesList__B9xUo"};